export default {
  methods: {
    group(value) {
      let prepared = [];
      value.forEach(wt => {
        let group = prepared.find(group => group.id === wt.category.id);
        if(group === undefined) {
          group = {
            id: wt.category.id,
            name: wt.category.name,
            children: []
          }
          prepared.push(group)
        }
        group.children.push(wt);
      })
      return prepared;
    }
  }
}
